import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding, withEnabledBlockingInitialNavigation, withInMemoryScrolling, withViewTransitions } from '@angular/router';
import { providePrimeNG } from 'primeng/config';
import { appRoutes } from './app.routes';
import paltaPreset from '@/layout/preset/palta.preset';
import { provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';
import { CookieService } from 'ngx-cookie-service';
import { JwtModule } from '@auth0/angular-jwt';
import { authInterceptor } from '@/shared/interceptors/auth.interceptor';
import { refreshTokenInterceptor } from '@/shared/interceptors/refresh-token.interceptor';
import { ConfigOption, provideFormlyCore } from '@ngx-formly/core';
import { withFormlyBootstrap } from '@ngx-formly/bootstrap';
import { withFormlyPrimeNG } from '@ngx-formly/primeng';
import { SelectType } from '@/main/pages/alerts/components/types/select-type/select-type.type';
import { NumberType } from '@/main/pages/alerts/components/types/number-type/number-type.type';
import { TextareaType } from '@/main/pages/alerts/components/types/textarea-type/textarea-type.type';
import { TimeType } from '@/main/pages/alerts/components/types/time-type/time-type.type';
import { LOCALE_ID } from '@angular/core';
import localeEsAr from '@angular/common/locales/es-AR';
import { registerLocaleData } from '@angular/common';

export function tokenGetter() {
    return localStorage.getItem('token-sf');
}
const primeNGConfig = withFormlyPrimeNG();
const customConfig: ConfigOption = {
    types: [
        { name: 'p-select', component: SelectType },
        { name: 'p-number', component: NumberType },
        { name: 'p-textarea', component: TextareaType },
        { name: 'p-time', component: TimeType }
    ]
};
primeNGConfig.push(customConfig);
registerLocaleData(localeEsAr);

export const appConfig: ApplicationConfig = {
    providers: [
        { provide: LOCALE_ID, useValue: 'es-AR' },
        provideRouter(appRoutes, withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }), withEnabledBlockingInitialNavigation(), withViewTransitions(), withComponentInputBinding()),
        provideHttpClient(withFetch(), withInterceptors([authInterceptor, refreshTokenInterceptor])),
        provideAnimationsAsync(),
        providePrimeNG({
            translation: {
                firstDayOfWeek: 1,
                dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
                dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
                dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
                monthNames: [
                    'Enero', 'Febrero', 'Marzo', 'Abril',
                    'Mayo', 'Junio', 'Julio', 'Agosto',
                    'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
                ],
                monthNamesShort: [
                    'Ene', 'Feb', 'Mar', 'Abr',
                    'May', 'Jun', 'Jul',
                    'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
                ],
                today: 'Hoy',
                clear: 'Limpiar'
            },
            theme: {
                preset: paltaPreset,
                options: {
                    darkModeSelector: '.dark'
                }
            }
        }),
        provideLottieOptions({
            player: () => player
        }),
        importProvidersFrom(
            JwtModule.forRoot({
                config: {
                    tokenGetter: tokenGetter
                }
            }),
            CookieService
        ),
        provideFormlyCore(primeNGConfig)
    ]
};
